import {digg} from "diggerize"

/**
 *
 * @param {object} props
 * @returns {object}
 */
function linkProps(props) {
  return {
    adminLayout: digg(props, "adminLayout"),
    userLayout: digg(props, "userLayout")
  }
}

export default linkProps
